<template>
  <admin-settings v-if="isAdmin" />
  <team-admin-settings v-else-if="isTeamAdmin" />
  <user-settings v-else-if="loggedIn" />
  <div v-else>
    <h3>Geschlossener Bereich</h3>
    <h4>Login erforderlich</h4>
  </div>
</template>
<script>
import UserPermissionsService from "../../services/UserPermissionsService/UserPermissionsService";
import AdminSettings from "../admin/AdminSettings.vue";
import TeamAdminSettings from "../teamAdmin/TeamAdminSettings.vue";
import UserSettings from "./UserSettings.vue";
export default {
  name: "Settings",
  components: {
    AdminSettings,
    TeamAdminSettings,
    UserSettings,
  },
  computed: {
    loggedIn() {
      var user = localStorage.getItem("user");
      return user && user != null;
    },
    isAdmin() {
      if (!this.loggedIn) {
        return false;
      }
      return UserPermissionsService.userHasRole("LEAGUE_MAINTAINER");
    },
    isTeamAdmin() {
      if (!this.loggedIn) {
        return false;
      }
      return UserPermissionsService.userHasRole("TEAM_MANAGER");
    },
  },
};
</script>

<style lang="scss" scoped></style>
